//#region IMPORT
import React, { useRef } from 'react';
import dayjs from 'dayjs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import {
  Box as MuiBox,
  Box,
  Button as MuiButton,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Tabs,
  Tab,
  Collapse,
  Tooltip,
  tooltipClasses,
  styled,
  Switch,
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../../Assets/Icon/CustomIcons';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { resetAddButtonError } from '../../../../Reducer/StatusFlagsReducer';
// 필터관련 컴포넌트
import { GridFilterButton } from '../../../../Components/GridFilterButton';
import { GridFilterSummary } from '../../../../Components/GridFilterSummary';
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';
import { getColumnDefs1 } from './HAZ_BASIC_02_ColumnDefs';

/** 우측 툴바 IconButton 공통 크기·원형 (추가/검색/삭제/엑셀 버튼 통일) */
const toolbarIconBtnSx = {
  border: 1,
  borderRadius: '50%',
  width: 40,
  height: 40,
  boxSizing: 'border-box',
  padding: '8px',
};

function HAZ_BASIC_02(props) {
  const dispatch = useDispatch();
  const isAddButtonError = useSelector(
    (state) => state.StatusFlags.isAddButtonError
  );

  // 커스터마이징된 Tooltip 생성
  const LargeTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#4CAF50', // 본체 배경 초록
      color: '#fff',
      fontSize: '0.9rem',
      padding: theme.spacing(1),
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#4CAF50', // 꼬리도 동일 색으로!
    },
  }));

  // Grid Options
  const gridOptions = {
    singleClickEdit: true,
    rowClassRules: {
      'new-row': (params) => params.data && params.data.newYn === 'Y', // params.data가 존재하는지 확인 후 처리
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
    isExternalFilterPresent: () => true, // 외부 필터 사용
    doesExternalFilterPass(node) {
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      // 선택된 필터 값으로 통과 여부 판단
      const filters = selectedFiltersRef.current || {};
      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        return values.includes(node.data[field]);
      });
    },
  };

  // 상단 영역 ref
  const containerRef = useRef(null);
  const topRef = useRef(null);
  const buttonRef = useRef(null);

  // 필터관련
  const [gridApi, setGridApi] = React.useState(null);
  const [gridColumnApi, setGridColumnApi] = React.useState(null);
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [headerMap, setHeaderMap] = React.useState({});
  const [isFiltered, setIsFiltered] = React.useState(false);
  const selectedFiltersRef = React.useRef(selectedFilters);

  React.useEffect(() => {
    selectedFiltersRef.current = selectedFilters;
    if (props.gridRef1?.current?.api) {
      props.gridRef1.current.api.onFilterChanged(); // 필터 적용
    }
  }, [selectedFilters]);

  // 컬럼정보
  const columnDefs1 = getColumnDefs1(props);

  return (
    <Box sx={{ height: '100%', pt: 1 }}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          borderColor: 'divider',
          borderRadius: '10px',
          p: 2,
          pt: 1,
          bgcolor: '#FFF',
          // mt: 1,
        }}
      >
        <Stack
          ref={containerRef}
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            minHeight: 0,
          }}
        >
          <React.Fragment>
            <Box ref={topRef}>
              {/* 상단 타이틀 + 버튼 + 스위치 */}
              <Box
                sx={{
                  flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  pb: 1,
                }}
              >
                {/* 제목 + 필터 한 그룹 */}
                <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: '1.05rem',
                      fontWeight: 'bold',
                      color: '#2CA900',
                      mr: 1, // 오른쪽으로 16px 여백
                    }}
                  >
                    안전인증 자율 안전확인신고
                  </Typography>
                </MuiBox>

                <MuiButton
                  sx={{
                    m: 1,
                    opacity: 0, // 투명
                    pointerEvents: 'none', // 클릭 방지
                    borderColor: 'transparent',
                  }}
                  variant="outlined"
                >
                  빈 버튼
                </MuiButton>

                {/* Toggle 버튼 */}
                <Switch
                  checked={props.showTable}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    props.SaveLogic0(checked);
                    props.setShowTable(checked);
                  }}
                  color="primary"
                />
              </Box>

              {/* 토글 상태에 따라 테이블 표시 */}
              {props.showTable && (
                <TableContainer
                  // ref={tableRef}
                  component={Paper}
                  sx={{
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                      width: '8px',
                      height: '8px', // 가로 스크롤바도 동일한 높이로 설정
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0, 0, 0, 0.1)', // 스크롤바 색상
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1', // 스크롤바 트랙 색상
                    },
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: '8px',
                  }}
                >
                  <Table>
                    <colgroup>
                      <col
                        style={{
                          width: '_item',
                        }}
                      />
                    </colgroup>
                    <TableBody>
                      <TableRow
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '16px',
                        }}
                      >
                        {/* 기계 · 기구항목 + 버튼 */}
                        <TableCell
                          sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                            fontSize: '16px',
                            backgroundColor: 'rgb(250, 250, 250)',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px', // 타이틀과 버튼 간 간격
                          }}
                          colSpan={3} // 필요에 따라 조정
                        >
                          기계 · 기구항목
                          <Tooltip
                            title={`아래의 '기계/기구' 텍스트를 클릭하면 아래 드롭 영역이 열립니다.
드롭 영역에서 '규격 및 형식별 적용범위'를 확인할 수 있습니다.
드롭 영역이 열리면 그리드는 화면에서 숨겨지고,
다시 택스트를 클릭하면 드롭 영역이 닫히고 그리드가 다시 표시됩니다.`}
                            arrow
                            placement="top"
                            enterDelay={300}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: '0.9rem',
                                  padding: '8px 12px',
                                  maxWidth: 500,
                                  backgroundColor: '#333',
                                  whiteSpace: 'pre-wrap',
                                },
                              },
                            }}
                          >
                            <button
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '100%',
                                color: '#f44336',
                                border: '1px #e0e0e0 solid',
                                backgroundColor: '#fff',
                                width: '1.4rem',
                                height: '1.4rem',
                                cursor: 'pointer',
                              }}
                            >
                              <Icon.QuestionMark
                                style={{ width: '1.2rem', height: '1.2rem' }}
                              />
                            </button>
                          </Tooltip>
                        </TableCell>

                        {/* Tabs */}
                        <TableCell sx={{ padding: 0 }}>
                          <Tabs
                            value={props.tabValue}
                            onChange={props.handleTabChange}
                            sx={{
                              minHeight: 'auto',
                              '& .MuiTab-root': {
                                fontSize: '14px',
                              },
                            }}
                          >
                            {props.items?.map((tab, idx) => (
                              <Tab
                                key={idx}
                                label={tab.rangeType}
                                sx={{
                                  minHeight: 'auto',
                                  padding: '4px 12px',
                                  minWidth: '300px',
                                }}
                              />
                            ))}
                          </Tabs>
                        </TableCell>
                      </TableRow>

                      {/* 아이템 텍스트 리스트 */}
                      <TableRow>
                        {/* 설명 버튼 */}

                        {/* item 영역 */}
                        <TableCell colSpan={2} sx={{ fontSize: '14px' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '8px', // 아이템 간 간격
                            }}
                          >
                            {props
                              .getCheckItemsByTab(props.tabValue)
                              ?.map((item) => (
                                <div
                                  key={item.value}
                                  onClick={() => props.handleItemClick(item)}
                                  style={{
                                    padding: '8px 10px', // 기존보다 살짝 넓게
                                    fontSize: '14px', // 기존 12px → 14px
                                    cursor: 'pointer',
                                    borderRadius: '4px',
                                    transition: 'background-color 0.2s',
                                    backgroundColor:
                                      props.selectedItem?.value === item.value
                                        ? 'rgba(0, 150, 255, 0.1)'
                                        : 'transparent',
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      'rgba(0, 150, 255, 0.05)')
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      props.selectedItem?.value === item.value
                                        ? 'rgba(0, 150, 255, 0.1)'
                                        : 'transparent')
                                  }
                                >
                                  {item.label}
                                </div>
                              ))}
                          </div>
                        </TableCell>
                      </TableRow>

                      {/* Drop 영역 (애니메이션) */}
                      <TableRow>
                        <TableCell colSpan={3} sx={{ padding: 0 }}>
                          <Collapse
                            in={Boolean(props.selectedItem)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <div
                              style={{
                                padding: '8px',
                                fontSize: '14px',
                                backgroundColor: '#fafafa',
                                borderTop: '1px solid #ddd',
                                whiteSpace: 'pre-line', // 줄바꿈 유지
                                position: 'relative',
                                flex: 1, // 남은 공간 꽉 채움
                                minHeight: 0, // overflow 스크롤이 부모로 안 튀게 함
                                overflowY: 'auto',
                              }}
                            >
                              {/* 설명 텍스트 */}
                              <div
                                style={{
                                  padding: '12px 16px',
                                  fontSize: '15px',
                                  lineHeight: 1.6,
                                  color: '#333',
                                  backgroundColor: '#fff',
                                  borderLeft: '4px solid #1976d2', // 강조 라인 (파란색)
                                  borderRadius: '4px',
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                  marginBottom: '8px',
                                }}
                              >
                                {props.selectedItem?.description ||
                                  '설명이 없습니다.'}
                              </div>

                              {/* 오른쪽 아래 아이콘 버튼 */}
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  marginTop: '8px',
                                }}
                              >
                                <Tooltip
                                  title="접기"
                                  arrow
                                  placement="top"
                                  enterDelay={300}
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: '0.9rem',
                                        padding: '8px 12px',
                                        maxWidth: 500,
                                        backgroundColor: '#333',
                                        whiteSpace: 'pre-wrap',
                                      },
                                    },
                                  }}
                                >
                                  <button
                                    onClick={() => props.setSelectedItem(null)} // 닫기
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer',
                                      padding: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '4px',
                                    }}
                                  >
                                    <KeyboardArrowUpIcon
                                      style={{
                                        fontSize: '20px',
                                        color: '#666',
                                      }}
                                    />
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>

            {/* AG Grid */}
            <div
              style={{
                display:
                  props.selectedItem && props.showTable ? 'none' : 'flex',
                flexDirection: 'column',
                flex: 1, // 남은 공간을 전부 차지
                minHeight: 0, // VERY IMPORTANT: 내부 스크롤이 부모로 튀지 않게 함
                width: '100%',
              }}
            >
              {/* 버튼 전체 영역 */}
              <div
                ref={buttonRef}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between', // 좌우 끝으로 배치
                  alignItems: 'center',
                  gap: '4px',
                  margin: '8px 0',
                }}
              >
                {/* 왼쪽: GridFilterButton */}
                <div>
                  {props.gridRef1 && (
                    <GridFilterButton
                      gridRef={props.gridRef1}
                      gridApi={gridApi}
                      gridColumnApi={gridColumnApi}
                      rowData={props.rowData1}
                      selectedFiltersRef={selectedFiltersRef}
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                      setIsFiltered={setIsFiltered}
                      setHeaderMap={setHeaderMap}
                      headerMap={headerMap}
                    />
                  )}
                </div>

                {/* 오른쪽: 나머지 버튼들 */}
                <div style={{ display: 'flex', gap: '4px' }}>
                  {/* motion.div는 추가 버튼 전용 */}
                  <motion.div
                    style={{ display: 'flex', alignItems: 'center' }}
                    animate={
                      isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }
                    }
                    transition={
                      isAddButtonError
                        ? {
                            duration: 0.6,
                            repeat: Infinity,
                            repeatDelay: 1,
                            ease: 'easeOut',
                          }
                        : { duration: 0 }
                    }
                  >
                    <LargeTooltip title="추가" arrow placement="top">
                      <IconButton
                        color="primary"
                        sx={toolbarIconBtnSx}
                        onClick={() => {
                          if (!props.validateSelection()) return;

                          dispatch(resetAddButtonError());
                          GridFunctions.addClick(
                            props.gridRef1,
                            props.setChangedRowData1
                          );

                          // ✅ 새로 추가된 로우에 기본값 세팅
                          const api = props.gridRef1.current.api;
                          const newRowNode = api.getDisplayedRowAtIndex(0); // 첫 번째 ROW

                          if (newRowNode) {
                            const today = dayjs();
                            newRowNode.setDataValue(
                              'inspectionDate',
                              today.format('YYYY-MM-DD')
                            );
                          }
                        }}
                        variant="outlined"
                      >
                        <AddIcon fontSize="small" style={{ margin: 0 }} />
                      </IconButton>
                    </LargeTooltip>
                  </motion.div>

                  {/* 검색 버튼 */}
                  <LargeTooltip title="검색" arrow placement="top">
                    <IconButton
                      color="secondary"
                      sx={toolbarIconBtnSx}
                      onClick={() => {
                        if (!props.validateSelection()) return;
                        props.SearchLogic1();
                      }}
                      variant="outlined"
                    >
                      <RefreshIcon fontSize="small" style={{ margin: 0 }} />
                    </IconButton>
                  </LargeTooltip>

                  {/* 삭제 버튼 */}
                  <LargeTooltip title="삭제" arrow placement="top">
                    <IconButton
                      color="error"
                      sx={toolbarIconBtnSx}
                      variant="outlined"
                      onClick={(e) => {
                        if (!props.validateSelection()) return;

                        const newRowExists = props.selectedRowData1.some(
                          (row) => row.newYn === 'Y'
                        );

                        if (!newRowExists) {
                          props.MarkedForDeletion1(props.selectedRowData1);
                        } else {
                          props.NewYnErrorMsg();
                        }
                      }}
                    >
                      <DeleteIcon fontSize="small" style={{ margin: 0 }} />
                    </IconButton>
                  </LargeTooltip>

                  {/* 엑셀 업로드 버튼 */}
                  <LargeTooltip title="엑셀 업로드" arrow placement="top">
                    <IconButton
                      color="info"
                      sx={toolbarIconBtnSx}
                      variant="outlined"
                      onClick={() => {
                        if (!props.validateSelection()) return;
                        props.fileInputRef?.current?.click();
                      }}
                    >
                      <Icon.FolderUpload
                        style={{ fontSize: 'small', margin: 0 }}
                      />
                    </IconButton>
                  </LargeTooltip>

                  {/* 엑셀 다운로드 버튼 */}
                  <LargeTooltip title="엑셀 다운로드" arrow placement="top">
                    <IconButton
                      color="success"
                      sx={toolbarIconBtnSx}
                      variant="outlined"
                      onClick={() => {
                        if (!props.validateSelection()) return;
                        props.ExcelDownload1();
                      }}
                    >
                      <Icon.FolderDownload
                        style={{ fontSize: 'small', margin: 0 }}
                      />
                    </IconButton>
                  </LargeTooltip>
                </div>
              </div>

              {props.gridRef1 && (
                <GridFilterSummary
                  isFiltered={isFiltered}
                  selectedFilters={selectedFilters}
                  headerMap={headerMap}
                  setSelectedFilters={setSelectedFilters}
                />
              )}
              <AgGridReact
                getRowId={(params) => {
                  return params.data.no;
                }}
                ref={props.gridRef1}
                onGridReady={(params) => {
                  setGridApi(params.api);
                  setGridColumnApi(params.columnApi);
                }}
                animationRows={true}
                columnDefs={columnDefs1}
                rowData={props.rowData1}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                defaultColDef={{
                  cellDataType: false,
                  minWidth: 100,
                  editable: true,
                  resizable: true,
                  sortable: true,
                  filter: true,
                  floatingFilter: true,
                }}
                gridOptions={gridOptions}
                rowSelection={'multiple'}
                singleClickEdit={true}
                onCellClicked={(e) => {
                  // 필요 시 특정 행 선택 등 처리
                  const gridApi = props.gridRef1.current.api;
                  const clickedRowIndex = e.rowIndex;

                  const isCheckboxClick = e.event?.target?.type === 'checkbox';

                  if (!isCheckboxClick) {
                    gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                    gridApi.setFocusedCell(clickedRowIndex, 'coNm');

                    const copied = JSON.parse(JSON.stringify(e.data));
                    props.handleRowSelection1(copied, clickedRowIndex);

                    gridApi
                      .getDisplayedRowAtIndex(clickedRowIndex)
                      ?.setSelected(true, false);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi.getSelectedNodes();
                  const selectedData = selectedNodes.map((n) => n.data);

                  props.selectedRowNosRef1.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData1(selectedData);
                }}
                onCellValueChanged={(e) => {
                  const key = e.data.no;

                  e.node.setData({
                    ...e.data,
                    editYn: 'Y',
                  });

                  props.setChangedRowData1?.((prev) => {
                    const filtered = prev.filter((row) => row.no !== key);
                    return [...filtered, { ...e.data, editYn: 'Y' }];
                  });
                }}
                stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
              />
              {/* 파일 업로드 다이얼로그 */}
              {props.fileModalToggle && (
                <FileUploadDialog
                  open={props.fileModalToggle}
                  onClose={() => {
                    props.setFileModalToggle(false);
                  }}
                  gridRef={props.gridRef1}
                  selectedRowData={props.selectedRowData1}
                  setSelectedRowData={props.setSelectedRowData1}
                  setChangedRowData={props.setChangedRowData1}
                  fileNameField="certificateFileName"
                  saveNameField="certificateSaveName"
                  filePathField="certificateFilePath"
                  previewFilePathField="previewFilePath"
                  SaveLogicPreview={props.SaveLogicPreview}
                  DownloadLogic={props.DownloadLogic1}
                  DeleteLogicFile={props.DeleteLogicFile}
                />
              )}
            </div>
          </React.Fragment>
        </Stack>
      </Box>
      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1(file);
            // 같은 파일을 다시 선택할 수 있도록 초기화
            e.target.value = '';
          }
        }}
      />
    </Box>
  );
}

export default HAZ_BASIC_02;
